export default __webpack_public_path__ + "741fb483ff3b42b8fa0e833619f2de84.gif";